
 
import { axiosRequest, AxiosRequestOptions } from "../api";
import  config from '../../config';


import {StartEmergencyCallInput, StartEmergencyCallOutput, DiscardCallInput, DiscardCallOutput, CallDetailsOutput, SendMessageInput, SendMessageOutput, SendBulkMessageInput, SendBulkMessageOutput, UploadAttachmentOutput, MessagesSeenInput, MessagesSeenOutput, ChatMessagesOutput, UpdateCallStatusInput, UpdateCallStatusOutput } from '../../types/communication';

export default  {
 
    
    startEmergencyCall(data : StartEmergencyCallInput, options?: AxiosRequestOptions) { 
        return axiosRequest< StartEmergencyCallOutput, StartEmergencyCallInput >("POST",`${config.apiUrl.communication}/CommunicationCommand/StartEmergencyCall`,data, options);
    },
 
    
    discardCall(data : DiscardCallInput, options?: AxiosRequestOptions) { 
        return axiosRequest< DiscardCallOutput, DiscardCallInput >("POST",`${config.apiUrl.communication}/CommunicationCommand/DiscardCall`,data, options);
    },
 
    
    callDetails(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CallDetailsOutput >("GET",`${config.apiUrl.communication}/CommunicationQuery/CallDetails${queryParams || ""}`,undefined, options);
    },
 
    
    sendMessage(data : SendMessageInput, options?: AxiosRequestOptions) { 
        return axiosRequest< SendMessageOutput, SendMessageInput >("POST",`${config.apiUrl.communication}/CounselingChatCommand/SendMessage`,data, options);
    },
 
    
    sendBulkMessage(data : SendBulkMessageInput, options?: AxiosRequestOptions) { 
        return axiosRequest< SendBulkMessageOutput, SendBulkMessageInput >("POST",`${config.apiUrl.communication}/CounselingChatCommand/SendBulkMessage`,data, options);
    },
 
    
    sendBulkFileMessage(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest< SendBulkMessageOutput >("POST",`${config.apiUrl.communication}/CounselingChatCommand/SendBulkFileMessage`,data, options);
    },
 
    
    uploadAttachment(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest< UploadAttachmentOutput >("POST",`${config.apiUrl.communication}/CounselingChatCommand/UploadAttachment`,data, options);
    },
 
    
    messagesSeen(data : MessagesSeenInput, options?: AxiosRequestOptions) { 
        return axiosRequest< MessagesSeenOutput, MessagesSeenInput >("POST",`${config.apiUrl.communication}/CounselingChatCommand/MessagesSeen`,data, options);
    },
 
    
    chatMessages(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< ChatMessagesOutput >("GET",`${config.apiUrl.communication}/CounselingChatQuery/ChatMessages${queryParams || ""}`,undefined, options);
    },
 
    
    updateCallStatus(data : UpdateCallStatusInput, options?: AxiosRequestOptions) { 
        return axiosRequest< UpdateCallStatusOutput, UpdateCallStatusInput >("POST",`${config.apiUrl.communication}/Hooks/UpdateCallStatus`,data, options);
    },
 
    
    cachedClientVersions(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest  ("GET",`${config.apiUrl.communication}/ManagerCore/CachedClientVersions${queryParams || ""}`,undefined, options);
    },
 
    
    invalidateClientVersionsCache(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest  ("POST",`${config.apiUrl.communication}/ManagerCore/InvalidateClientVersionsCache`,data, options);
    },

};